export default "__VITE_ASSET__B2pKIbXU__"